module.exports = __webpack_public_path__ + "static/img/icon-message.a8dfd671.svg";